import i18n from "../../../../i18n";
import { onClickReport } from "../../../../utils/page";
import { callReports } from "./license/request-license.logic";
import { have } from "../../../../utils/menu-context";

export const createReportItems = ({ props, modelRef, id }) => {
    return [
        ...createReportFishingLicense({ props, modelRef, id }),
        ...createReportLicenseRequest({ props, modelRef, id }),
        ...createReportLicenseRequestChangeTool({ props, modelRef, id }),
        ...createReportLicenseRequestChangeInfo({ props, modelRef, id }),
        ...createReportLicenseRequestRenew({ props, modelRef, id }),
        ...createReportLicenseRequestChangeVesselReplacement({ props, modelRef, id }),
        ...createReportLicenseRequestChangeArea({ props, modelRef, id }),
        ...createReportTransferRequest({ props, modelRef, id }),
        ...createReportRequestReplacement({ props, modelRef, id }),
        ...createReportCancelRequest({ props, modelRef, id }),
        // ...createReportRevokeLicense({ props, modelRef, id }),
    ]
};

export const createReportLicenseRequest = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["requestLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
            },
            text: i18n.global.t("views.report.licenseRequest"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequest", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequest_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible =  ["requestLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChecklist"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChecklist", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChecklist_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible = ["requestLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestReceive"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestReceive", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestReceive_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["approve", "notApprove", "appeal"];
                const checkVisible = ["requestLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestResult"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestResult", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestReject_${modelRef.requestCode}.pdf`
                });
            },
        },
    ]
};

export const createReportLicenseRequestChangeTool = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitModify", "waitLawyerAudit","waitRDAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["changeLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                && ["tool"].includes(modelRef?.refChangeLicenseObjective?.key)
            },
            text: i18n.global.t("views.report.licenseRequestChangeTool"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeTool", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeTool_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitModify", "waitLawyerAudit", "waitRDAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible =  ["changeLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["tool"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeToolChecklist"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeToolChecklist", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeToolChecklist_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitLawyerAudit", "waitArgueLawyer", "waitRDAudit", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible = ["changeLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key) && ["tool"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeToolReceive"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeToolReceive", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeToolReceive_${modelRef.requestCode}.pdf`
                });
            },
        },
        {

            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["approve", "notApprove", "appeal"];
                const checkVisible = ["changeLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["tool"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeToolResult"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeToolResult", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeToolResult_${modelRef.requestCode}.pdf`
                });
            },
        },
    ]
};

export const createReportLicenseRequestChangeInfo = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitModify", "waitLawyerAudit",  "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["changeLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["editRegistration"].includes(modelRef?.refChangeLicenseObjective?.key)
            },
            text: i18n.global.t("views.report.licenseRequestChangeInfo"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeInfo", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeInfo_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitModify", "waitLawyerAudit", "waitRDAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible =  ["changeLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["editRegistration"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeInfoChecklist"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeInfoChecklist", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeInfoChecklist_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible = ["changeLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["editRegistration"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeInfoReceive"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeInfoReceive", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeInfoReceive_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["approve", "notApprove", "appeal"];
                const checkVisible = ["changeLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["editRegistration"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeInfoResult"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeInfoResult", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeInfoResult_${modelRef.requestCode}.pdf`
                });
            },
        },
    ]
};

export const createReportLicenseRequestChangeVesselReplacement = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["changeLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["replaceBoat"].includes(modelRef?.refChangeLicenseObjective?.key)
            },
            text: i18n.global.t("views.report.licenseRequestChangeVesselReplacement"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeVesselReplacement", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeVesselReplacement_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitModify", "waitLawyerAudit", "waitRDAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible =  ["changeLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["replaceBoat"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeVesselReplacementChecklist"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeVesselReplacementChecklist", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeVesselReplacementChecklist_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible = ["changeLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["replaceBoat"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeVesselReplacementReceive"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeVesselReplacementReceive", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeVesselReplacementReceive_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["approve", "notApprove", "appeal"];
                const checkVisible = ["changeLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["replaceBoat"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeVesselReplacementResult"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeVesselReplacementResult", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeVesselReplacementResult_${modelRef.requestCode}.pdf`
                });
            },
        },
    ]
};

export const createReportLicenseRequestChangeArea = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitModify", "waitRDAudit", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["changeLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["moveAshore"].includes(modelRef?.refChangeLicenseObjective?.key)
            },
            text: i18n.global.t("views.report.licenseRequestChangeArea"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeArea", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeArea_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitModify", "waitLawyerAudit", "waitRDAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible =  ["changeLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["moveAshore"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeAreaChecklist"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeAreaChecklist", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeAreaChecklist_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible = ["changeLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["moveAshore"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeAreaReceive"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeAreaReceive", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeAreaReceive_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["approve", "notApprove", "appeal"];
                const checkVisible = ["changeLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
                    && ["moveAshore"].includes(modelRef?.refChangeLicenseObjective?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestChangeAreaResult"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestChangeAreaResult", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestChangeAreaResult_${modelRef.requestCode}.pdf`
                });
            },
        }
    ]
};

export const createReportLicenseRequestRenew = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["renewLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
            },
            text: i18n.global.t("views.report.licenseRequestRenew"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestRenew", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestRenew_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible =  ["renewLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestRenewChecklist"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestRenewChecklist", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestRenewChecklist_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible = ["renewLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestRenewReceive"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestRenewReceive", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestRenewReceive_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["approve", "notApprove", "appeal"];
                const checkVisible = ["renewLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.licenseRequestRenewResult"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "licenseRequestRenewResult", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `licenseRequestRenewResult_${modelRef.requestCode}.pdf`
                });
            },
        }
    ]
};

export const createReportTransferRequest = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["transferLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
            },
            text: i18n.global.t("views.report.transferLicense"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "transferLicense", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `transferLicense_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["transferLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
            },
            text: i18n.global.t("views.report.transferLicenseChecklist"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "transferLicenseChecklist", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `transferLicenseChecklist_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible = ["transferLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.transferLicenseReceive"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "transferLicenseReceive", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `transferLicenseReceive_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["approve", "notApprove", "appeal"];
                const checkVisible = ["transferLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.transferLicenseResult"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "transferLicenseResult", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `transferLicenseResult_${modelRef.requestCode}.pdf`
                });
            },
        }
    ]
};

export const createReportRequestReplacement = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["requestReplacement"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
            },
            text: i18n.global.t("views.report.requestReplacement"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "requestReplacement", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `requestReplacement_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["requestReplacement"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
            },
            text: i18n.global.t("views.report.requestReplacementChecklist"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "requestReplacementChecklist", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `requestReplacementChecklist_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible = ["requestReplacement"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.requestReplacementReceive"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "requestReplacementReceive", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `requestReplacementReceive_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["approve", "notApprove", "appeal"];
                const checkVisible = ["requestReplacement"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.requestReplacementResult"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "requestReplacementResult", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `requestReplacementResult_${modelRef.requestCode}.pdf`
                });
            },
        }
    ]
};

export const createReportCancelRequest = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["cancelLicense"].includes(modelRef?.refRequestType?.key) && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key)
            },
            text: i18n.global.t("views.report.cancelLicense"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "cancelLicense", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `cancelLicense_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitModify", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["cancelLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)
            },
            text: i18n.global.t("views.report.cancelLicenseChecklist"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "cancelLicenseChecklist", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `cancelLicenseChecklist_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                const checkVisible = ["cancelLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys}) && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.cancelLicenseReceive"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "cancelLicenseReceive", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `cancelLicenseReceive_${modelRef.requestCode}.pdf`
                });
            },
        },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    "forLawyerAuditor",
                    "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["approve", "notApprove", "appeal"];
                const checkVisible = ["cancelLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key);
                return checkVisible
            },
            text: i18n.global.t("views.report.cancelLicenseResult"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "cancelLicenseResult", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `cancelLicenseResult_${modelRef.requestCode}.pdf`
                });
            },
        }
    ]
};

export const createReportFishingLicense = ({ props, modelRef, id }) => {
    const { menuContext } = props;
    return [
        // {
        //     visible: () => {
        //         const keys = [
        //             //"forSendRequest",
        //             "forReviewRequest",
        //             // "forLawyerAuditor",
        //             // "forRDAuditor",
        //             "forDofCenter",
        //             "forAuthorized"
        //         ];
        //         return have({menuContext, keys})
        //     },
        //     text: i18n.global.t("views.report.fishingLicense"),
        //     icon: "pdf.svg",
        //     onClick: () => {
        //         onClickReport({
        //             callReport: () => callReports({ data: { reportName: "fishingLicense", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
        //             fileName: `fishingLicense_${modelRef.requestCode}.pdf`
        //         });
        //     },
        // },
        // {
        //     visible: () => {
        //         const keys = [
        //             //"forSendRequest",
        //             "forReviewRequest",
        //             // "forLawyerAuditor",
        //             // "forRDAuditor",
        //             "forDofCenter",
        //             "forAuthorized"
        //         ];
        //         return have({menuContext, keys})
        //     },
        //     text: i18n.global.t("views.report.fishingLicenseTailForm"),
        //     icon: "pdf.svg",
        //     onClick: () => {
        //         onClickReport({
        //             callReport: () => callReports({ data: { reportName: "fishingLicenseTailForm", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
        //             fileName: `fishingLicenseTailForm_${modelRef.requestCode}.pdf`
        //         });
        //     },
        // },
        {
            visible: () => {
                const keys = [
                    "forSendRequest",
                    "forReviewRequest",
                    // "forLawyerAuditor",
                    // "forRDAuditor",
                    "forDofCenter",
                    "forAuthorized"
                ];
                const visibleStatusKeys =  ["waitAcceptRequest", "waitLawyerAudit", "waitArgueLawyer", "waitDofCenterAudit", "waitApprove", "approve", "notApprove", "cancel", "appeal"];
                return ["requestLicense"].includes(modelRef?.refRequestType?.key)
                    && have({menuContext, keys})
                    && modelRef.fishingToolDeclarations?.length > 0
                    && visibleStatusKeys.includes(modelRef?.refStatus?.key)

            },
            text: i18n.global.t("views.report.fishingToolGillNet"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "fishingToolGillNet", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `fishingToolGillNet_${modelRef.requestCode}.pdf`
                });
            },
        },
        // {
        //     visible: () => false,
        //     text: i18n.global.t("views.report.vesselAgreement"),
        //     icon: "pdf.svg",
        //     onClick: () => {
        //         onClickReport({
        //             callReport: () => callReports({ data: { reportName: "vesselAgreement", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
        //             fileName: `vesselAgreement_${modelRef.requestCode}.pdf`
        //         });
        //     },
        // },
    ]
};

export const createReportRevokeLicense = ({ modelRef, id }) => {
    return [
        {
            visible: () => ["revoke"].includes(modelRef?.refLicenseStatus?.key),
            text: i18n.global.t("views.report.revokeLicense"),
            icon: "pdf.svg",
            onClick: () => {
                onClickReport({
                    callReport: () => callReports({ data: { reportName: "revokeLicense", licenseRequest: { id: id }, isDraft: false, isThaiNumber: true } }),
                    fileName: `revokeLicense_${modelRef.requestCode}.pdf`
                });
            },
        },
    ]
};
